/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 08.09.2016.
 */

import ShowcasePurchases from './showcase-purchases';

export default ShowcasePurchases;



// WEBPACK FOOTER //
// ./src/containers/ShowcasePurchases/index.js